import { IsNotEmpty } from 'class-validator';
import { IAnalyticsActivityEnum } from '../../../../src/common/enum/analytics-activity/analytics-activity.enum';
import { Mapper } from '../../../common/ddd/mapper.base';
import { SelfTopAppCategoryAppsEntity } from '../../../core/domain/entities/app-category-metrics/self-top-app-category-app.entity';

export class SelfTopAppCategoryAppsPersistenceResponse {
  @IsNotEmpty()
  [IAnalyticsActivityEnum.AppId]: string;

  @IsNotEmpty()
  [IAnalyticsActivityEnum.TotalDuration]: string;
}

export class SelfTopAppCategoryAppsEntityMapper
  implements Omit<Mapper<SelfTopAppCategoryAppsEntity, any>, 'toResponse'>
{
  toDomain(
    record: SelfTopAppCategoryAppsPersistenceResponse
  ): SelfTopAppCategoryAppsEntity {
    return SelfTopAppCategoryAppsEntityMapper.toDomain(record);
  }
  static toDomain(
    record: SelfTopAppCategoryAppsPersistenceResponse
  ): SelfTopAppCategoryAppsEntity {
    const entity = SelfTopAppCategoryAppsEntity.create({
      totalDuration: Number(record[IAnalyticsActivityEnum.TotalDuration]),
      appId: String(record[IAnalyticsActivityEnum.AppId]),
    });
    return entity;
  }
}
